<template>
  <template-info :bgImg="bgImg" title="วิธีการคำนวณ VAT">
    <div>
      <div class="tcvb-detail">
        ภาษีที่ต้องเสีย สามารถคำนวณได้จากการนำภาษีขาย<br />ทั้งเดือนภาษีมาหักด้วยภาษีซื้อทั้งเดือนภาษี
        <br />
        <br />
        หากมีภาษีซื้อมากกว่าภาษีขายจะขอคืนภาษีส่วนต่าง<br />เป็นเงินสดหรือยกเป็นเครดิตในเดือนถัดไปก็ได้
        ดังนี้
      </div>
      <div class="wrap-destop-size">
        <div class="tcvb-formula">
          <h4>ภาษีมูลค่าเพิ่ม = ภาษีขาย – ภาษีซื้อ</h4>
        </div>

        <div class="tcvb-explain">
          <div class="tcvbe-block">
            <div class="tcvbeb-topic">
              ภาษีขาย
              <img
                class="tcvbebt-icon"
                src="@/assets/icons/chevron-right-solid-colortext1.svg"
                alt="chevron-right"
              />
              ภาษีซื้อ
            </div>
            <div class="tcvbeb-detail" style="color: #f45a49;">
              ภาษีมูลค่าเพิ่ม <br />ที่ต้องนำส่ง
            </div>
          </div>

          <div class="tcvbe-block">
            <div class="tcvbeb-topic">
              ภาษีขาย
              <img
                class="tcvbebt-icon"
                src="@/assets/icons/chevron-left-solid-colortext1.svg"
                alt="chevron-right"
              />
              ภาษีซื้อ
            </div>
            <div class="tcvbeb-detail">
              ภาษีที่มีสิทธิขอคืน <br />หรือขอเครดิตภาษี
            </div>
          </div>
        </div>
      </div>
      <div class="tcvb-detail">
        ในแต่ละเดือนคุณจะเอาภาษีขายหักลบภาษีซื้อ <br />
        <br />
        ถ้าภาษีขายมากกว่าภาษีซื้อเช่นเดียวกับในกรณีนี้ <br />
        7 – 3.50 = 3.50 <br />
        เราก็จะนำส่งภาษีให้กับสรรพากร 3.50 บาท <br />
        <br />
        ดังนั้นถ้าเราทำ pricing strategy ที่ดี
        จะเห็นได้เลยว่าคนที่รับภาระภาษีมูลค่าเพิ่ม<br />ทั้งในด้านขายและซื้อไม่ใช่คุณเลย
        แต่เป็นผู้ซื้อสินค้าไปต่อจากคุณ
      </div>
    </div>
  </template-info>
</template>

<script>
import BackgroundImg from "@/assets/images/infos/vat_calculation.png";

export default {
  name: "VatCalculation",
  components: {},
  data() {
    const bgImg = BackgroundImg;
    return {
      bgImg: bgImg,
    };
  },
  methods: {
    goVatCondition2() {
      this.$router.push({ path: "/info/vat_condition_2" });
    },
  },
};
</script>

<style scoped>
.tcvb-detail {
  width: 100%;
  color: #393d43;
  margin-bottom: 16px;
  text-align: left;
}
.tcvb-formula {
  width: 100%;
  max-width: 351px;
  height: 53px;
  background: #99d6f1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}
.tcvb-explain {
  width: 100%;
  max-width: 351px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.tcvbe-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 167px;
  height: 109px;
  background: #eff1f5;
}
.tcvbeb-topic {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}
.tcvbebt-icon {
  margin: 0px 7px;
}
.tcvbeb-detail {
  font-weight: bold;
  text-align: center;
  color: #9bcc55;
}
/*size  >768px */
@media only screen and (min-width: 769px) {
  .tcvb-detail br {
    display: none;
  }
  .wrap-destop-size {
    display: flex;
  }
  .wrap-destop-size > div,
  .wrap-destop-size > div > div {
    margin-right: 33px;
  }
  .tcvb-formula {
    min-height: 109px;
  }
  .tcvb-formula h4 {
    font-size: 19px;
  }
}
</style>
